import React from 'react';
// import icon from '../../assets/images/icon.png';

const Welcome = () => {
  return (
    <div id='welcome' className="flex p-8 text-center justify-center mb-10 bg-cover bg-center h-72 mt-14" style={{ backgroundImage: `url('/bg-gradient.png')` }}>
      {/* <img src={icon} alt="" className='w-1/5 h-1/5 max-w-sm max-h-sm min-w-[90px] min-h-[90px] mr-10'/> */}
      <div className='my-auto'>
        {/* <h2 className="text-3xl font-bold text-gray-800 mb-4 font-serif">
          Welcome to 
          <span className='text-gradient'>&nbsp;cerise</span>
        </h2> */}
        <h2 className="text-6xl font-bold text-gray-800 mb-4 tracking-widest" style={{ fontFamily: 'Hatton, serif' }}>
          cerise
        </h2>
        <p className="text-center text-sm text-pink-500 tracking-tight italic font-serif">
        "Love begins with knowing"
        </p>
      </div>
    </div>
  )
}

export default Welcome